import { TFunction } from 'i18next';

export const TRANSLATABLE_UNIT_LOCALES = ['ru', 'uk', 'bg', 'he', 'ar', 'ka'];

export const getUnitValue = (unit: string, locale: string, t: TFunction) => {
  if (TRANSLATABLE_UNIT_LOCALES.includes(locale)) {
    return unit === 'lbs' ? t('units.lb') : t('units.kg');
  }
  return unit;
};
